export default __webpack_public_path__ + "static/media/file-upload-solid.72f08242.svg";